import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Supplier from "@/pages/Supplier";
import Operational from "@/pages/Operational";
import Volume from "@/pages/Volume";
import Finance from "@/pages/Finance";
import Shipments from "@/pages/Shipments";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <FilterProvider>
                  <DashboardLayout />
                </FilterProvider>
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="supplier" element={<Supplier />} />
            <Route path="operational" element={<Operational />} />
            <Route path="volume" element={<Volume />} />
            <Route path="finance" element={<Finance />} />
            <Route path="shipments" element={<Shipments />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
